// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================== */
/*        SCSS VARS       */
/* ===================== */
/* ===================== */
/*      CSS VARIABLES     */
/* ===================== */
:root {
  /* Text */
  --base-text-color: #1D1D1D;
  --darker-text-color: #202020;
  --brighter-text-color: #696969;
  /* UI */
  --base-ui-color: #E67817;
  --warning-ui-color: #F8A01E;
  --secondary-ui-color: #E8E4E4;
  /* Background */
  --base-bg-color: #F5F5F5;
  /* Grays */
  --color-gray: #B2B2B2;
  --color-gray-2: #9E9E9E;
  --color-gray-3: #D8D8D8;
  --color-dark-gray: #676767;
  /* Fonts */
  --main-font: Noto Sans;
  --secondary-font: Roboto;
  --third-font: Open Sans;
  --fourth-font: Dosis;
  /* Error */
  --error-color: #E00000;
  /* Border */
  --border-color: #D8D8D8;
}

.fk-filter-menu {
  display: flex;
  align-items: center;
}
.fk-filter-menu .fk-filter-menu-label {
  font: normal normal normal 14px/30px "Dosis";
  color: #B4B4B4;
}
.fk-filter-menu .fk-filter-menu-button {
  padding-right: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font: normal normal bold 16px/21px Noto Sans;
  color: #E67817;
  text-transform: unset;
}
.fk-filter-menu .fk-filter-menu-button:hover {
  background: none;
  opacity: 0.8;
  text-decoration: none;
}
.fk-filter-menu .fk-filter-menu-button.--with-arrow::after {
  content: "";
  border-top: 0px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid #E67817;
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
  position: absolute;
  right: 0;
  top: 6px;
}
.fk-filter-menu .fk-filter-menu-button.--selectable {
  padding: 0 15px;
}
.fk-filter-menu .fk-filter-menu-button.--action {
  max-width: unset;
  display: flex;
}
.fk-filter-menu .fk-filter-menu-button.--action svg {
  margin-right: 5px;
}

.fk-filter-menu-list li {
  font: normal normal normal 16px/21px "Noto Sans";
  color: #202020;
}
.fk-filter-menu-list li input {
  padding: 5px;
  font: normal normal normal 16px/21px "Noto Sans";
  color: #202020;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/components/filterMenu/filterMenu.styles.scss"],"names":[],"mappings":"AAAA,0BAAA;AACA,2BAAA;AACA,0BAAA;AA2BA,0BAAA;AACA,2BAAA;AACA,0BAAA;AAEA;EACE,SAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EAEA,OAAA;EACA,wBAAA;EACA,2BAAA;EACA,6BAAA;EAEA,eAAA;EACA,wBAAA;EAEA,UAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,0BAAA;EAEA,UAAA;EACA,sBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EAEA,UAAA;EACA,sBAAA;EAEA,WAAA;EACA,uBAAA;AChCF;;AA7BA;EACI,aAAA;EACA,mBAAA;AAgCJ;AA9BI;EACI,4CAAA;EACA,cAAA;AAgCR;AA7BI;EACI,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,4CAAA;EACA,cDTQ;ECUR,qBAAA;AA+BR;AA7BQ;EACI,gBAAA;EACA,YAAA;EACA,qBAAA;AA+BZ;AA3BY;EACI,WAAA;EACA,iCAAA;EACA,oCAAA;EACA,8BAAA;EACA,0BAAA;EACA,kCAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;AA6BhB;AAzBQ;EACI,eAAA;AA2BZ;AAxBQ;EACI,gBAAA;EACA,aAAA;AA0BZ;AAxBY;EACI,iBAAA;AA0BhB;;AAnBI;EACI,gDAAA;EACA,cDrDY;AC2EpB;AApBQ;EACI,YAAA;EACA,gDAAA;EACA,cD1DQ;ACgFpB","sourcesContent":["/* ===================== */\n/*        SCSS VARS       */\n/* ===================== */\n\n$base-text-color: #1D1D1D;\n$darker-text-color: #202020;\n$brighter-text-color: #696969;\n\n$base-ui-color: #E67817;\n$warning-ui-color: #F8A01E;\n$secondary-ui-color: #E8E4E4;\n\n$base-bg-color: #F5F5F5;\n\n$color-gray: #B2B2B2;\n$color-gray-2: #9E9E9E;\n$color-gray-3: #D8D8D8;\n$color-dark-gray: #676767;\n\n$main-font: \"Noto Sans\";\n$secondary-font: \"Roboto\";\n$third-font: \"Open Sans\";\n$fourth-font: \"Dosis\";\n\n$error-color: #E00000;\n\n$border-color: #D8D8D8;\n\n\n/* ===================== */\n/*      CSS VARIABLES     */\n/* ===================== */\n\n:root {\n  /* Text */\n  --base-text-color: #{$base-text-color};\n  --darker-text-color: #{$darker-text-color};\n  --brighter-text-color: #{$brighter-text-color};\n\n  /* UI */\n  --base-ui-color: #{$base-ui-color};\n  --warning-ui-color: #{$warning-ui-color};\n  --secondary-ui-color: #{$secondary-ui-color};\n\n  /* Background */\n  --base-bg-color: #{$base-bg-color};\n\n  /* Grays */\n  --color-gray: #{$color-gray};\n  --color-gray-2: #{$color-gray-2};\n  --color-gray-3: #{$color-gray-3};\n  --color-dark-gray: #{$color-dark-gray};\n\n  /* Fonts */\n  --main-font: #{$main-font};\n  --secondary-font: #{$secondary-font};\n  --third-font: #{$third-font};\n  --fourth-font: #{$fourth-font};\n\n  /* Error */\n  --error-color: #{$error-color};\n\n  /* Border */\n  --border-color: #{$border-color};\n}","@import '../../styles/variables';\n\n.fk-filter-menu {\n    display: flex;\n    align-items: center;\n\n    .fk-filter-menu-label {\n        font: normal normal normal 14px/30px $fourth-font;\n        color: #B4B4B4;\n    }\n\n    .fk-filter-menu-button {\n        padding-right: 15px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        font: normal normal bold 16px/21px Noto Sans;\n        color: $base-ui-color;\n        text-transform: unset;\n\n        &:hover {\n            background: none;\n            opacity: .8;\n            text-decoration: none;\n        }\n\n        &.--with-arrow {\n            &::after {\n                content: '';\n                border-top: 0px solid transparent;\n                border-bottom: 6px solid transparent;\n                border-left: 6px solid $base-ui-color;\n                transform: rotate(-135deg);\n                -webkit-transform: rotate(-135deg);\n                position: absolute;\n                right: 0;\n                top: 6px;\n            }\n        }\n\n        &.--selectable {\n            padding: 0 15px;\n        }\n\n        &.--action {\n            max-width: unset;\n            display: flex;\n\n            svg {\n                margin-right: 5px;\n            }\n        }\n    }\n}\n\n.fk-filter-menu-list {\n    li {\n        font: normal normal normal 16px/21px $main-font;\n        color: $darker-text-color;\n\n        input {\n            padding: 5px;\n            font: normal normal normal 16px/21px $main-font;\n            color: $darker-text-color;\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
